var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExistCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 15.3182,
    stroke: "#3B3F48",
    strokeOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0114 15.8182C28.0114 15.2722 28.454 14.8295 29 14.8295C36.8262 14.8295 43.1705 21.1739 43.1705 29C43.1705 36.8261 36.8262 43.1704 29 43.1704C21.1739 43.1704 14.8296 36.8261 14.8296 29C14.8296 25.0362 16.4584 21.451 19.0807 18.8803C19.4706 18.4981 20.0965 18.5043 20.4788 18.8942C20.861 19.2841 20.8548 19.91 20.4649 20.2923C18.2063 22.5064 16.8069 25.5889 16.8069 29C16.8069 35.7341 22.2659 41.1932 29 41.1932C35.7342 41.1932 41.1932 35.7341 41.1932 29C41.1932 22.2659 35.7342 16.8068 29 16.8068C28.454 16.8068 28.0114 16.3642 28.0114 15.8182Z",
    fill: "#3B3F48",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0114 19.7727C28.0114 19.2267 28.454 18.7841 29 18.7841C34.6421 18.7841 39.216 23.3579 39.216 29C39.216 34.6421 34.6421 39.2159 29 39.2159C23.358 39.2159 18.7841 34.6421 18.7841 29C18.7841 28.454 19.2268 28.0113 19.7728 28.0113C20.3188 28.0113 20.7614 28.454 20.7614 29C20.7614 33.5501 24.45 37.2386 29 37.2386C33.5501 37.2386 37.2387 33.5501 37.2387 29C37.2387 24.4499 33.5501 20.7613 29 20.7613C28.454 20.7613 28.0114 20.3187 28.0114 19.7727Z",
    fill: "#3B3F48",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22.7386C28.454 22.7386 28.0114 23.1812 28.0114 23.7273C28.0114 24.2733 28.454 24.7159 29 24.7159C31.3661 24.7159 33.2841 26.6339 33.2841 29C33.2841 31.366 31.3661 33.2841 29 33.2841C28.454 33.2841 28.0114 33.7267 28.0114 34.2727C28.0114 34.8187 28.454 35.2613 29 35.2613C32.4581 35.2613 35.2614 32.458 35.2614 29C35.2614 25.5419 32.4581 22.7386 29 22.7386Z",
    fill: "#3B3F48",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistCom);
export default __webpack_public_path__ + "static/media/ExistCom.57c4eb427bbba2e94b03ad3f0b9ead68.svg";
export { ForwardRef as ReactComponent };